import React from 'react';
//import css from './css.module.less';
import File from './FileTag';
import Product from './ProductTag';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import Left from './TopLeft';

const TagManager = (props) => {
  return (
    <React.Fragment>
      <Layout
        topLeft={<Left />}
        topRight={<React.Fragment />}
        elements={[{ child: <File /> }, { child: <Product /> }]}
      />
    </React.Fragment>
  );
};
export default TagManager;
